import { fg } from '@atlaskit/platform-feature-flags';
import { getEnv, EnvType } from '../../env';

const setEndpoint = (endpoint: string) => {
    const isJsmScaleTestAggCheckEnabled = fg('jsm_scale_60k_testing_in_help_center');

    if (
        isJsmScaleTestAggCheckEnabled &&
        getEnv().environment !== EnvType.PROD &&
        typeof process.env.AGG_BRANCH_SLUG === 'string' &&
        process.env.AGG_BRANCH_SLUG.length > 0
    ) {
        return endpoint.replace(process.env.AGG_BRANCH_SLUG, 'branch-issue-remove-rate-limit');
    }

    return endpoint;
};

export default {
    setEndpoint,
};
